import { render, staticRenderFns } from "./HallAgenda.vue?vue&type=template&id=2b0ff407&scoped=true"
import script from "./HallAgenda.vue?vue&type=script&lang=js"
export * from "./HallAgenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0ff407",
  null
  
)

export default component.exports